module.exports = __webpack_public_path__ + "fonts/fa-brands-400.36e7a8bf.woff";